import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { checkTextTranslation, checkTranslation, imageAddress, translate } from "../../utils/useful";
import * as actions from "../../stores/actionsList"


class MyHubs extends Component {
    state = {


    }
    componentDidMount() {
    }
    render() {

        return (
            <div className="w-100 bg-white" style={{ left: 0, width: '100%', }}>
                <div className="tower-body px-2">
                    <button className='px-1 flexc pt-3 pb-3' onClick={() => this.props.changeStage('Home')}>
                        <img src='/assets/icons/tower/arrow-left-gray.svg' width={'22px'} className='rtl-button' style={{ cursor: 'pointer' }} />
                        <p className="font-size-15 main-c2">{translate('Hubs')}</p>
                    </button>
                    {this.props.relations.relations.map((item, index) => {
                        return (

                            <div className="px-2 py-2 flexc w-100 bb-gray" style={{ transition: 'all 0.5s', cursor: 'pointer', }} onClick={() => { this.props.addNewWindow("hub", { path: [item.targetHub?.username], type: 'hub' }, "center"); this.props.toggle() }}>
                                {console.log('123456789', item)}
                                <div>
                                    <div className=" flexcc" style={{}}>
                                        <img src={imageAddress(item?.targetHub?.image, "profile", 'thumb')} style={{ width: '40px', height: 40, borderRadius: 10, objectFit: 'cover' }} />
                                    </div>
                                </div>
                                <div className="flexcb px-2 w-90">
                                    <p className="mb-0 w-90 text-bold" style={{ fontSize: 14, fontWeight: 500, color: '#202020', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTextTranslation(item?.targetHub?.name)}</p>
                                </div>
                            </div>
                        )

                    })}
                </div>
            </div>

        )
    }
}
const mapStateToProps = (state) => ({ settings: state.settings, user: state.user, resource: state.resource, notif: state.notif, relations: state.relations });
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(MyHubs);